import { FIELDS } from '../constants';

export const FIELD_SELECTORS = {
  [FIELDS.DATE]: '[name=date]',
  [FIELDS.ADULTS]: '[name=travellers-trigger]',
} as const;

// У Travellers и Datepicker нет рефов в пропсах, поэтому приходится фокусироваться через селектор
const focusBySelector = (selector: typeof FIELD_SELECTORS[keyof typeof FIELD_SELECTORS]) => {
  const element: HTMLElement | null = document.querySelector(selector);
  element?.focus();
};

export default focusBySelector;
